import React from "react";
import { View, Text, Image, Platform, StyleSheet } from "react-native";
import { STRINGS, COLORS } from "../../constants";
import { isMobileWeb } from "../../utils/helper";

const imageSize = Platform.OS === "web" ? 55 : 50;

/**
 * Returns the color value associated with a parking status.
 *
 * @param {string} parkingColor - The parking status color ("red", "yellow", "green", or any other value).
 * @returns {string} The corresponding color value from the COLORS object.
 */
const generateParkingStatusColor = (parkingColor) => {
  const parkingTextColor =
    parkingColor === "red"
      ? COLORS.parkingRed
      : parkingColor === "yellow"
      ? COLORS.parkingYellow
      : parkingColor === "green"
      ? COLORS.parkingGreen
      : COLORS.parkingGray;

  return parkingTextColor;
};

const ParkingIndicator = ({ parkingColor, parkingText, routeName = "" }) => {
  const hideParkingText = Platform.OS === "android" && routeName === "ParkingMapView" && !isMobileWeb();

  const parkingImage =
    parkingColor === "red"
      ? require("../../assets/images/redGauge.png")
      : parkingColor === "yellow"
      ? require("../../assets/images/yellowGauge.png")
      : parkingColor === "green"
      ? require("../../assets/images/greenGauge.png")
      : require("../../assets/images/noParkingData.png");

  return (
    // <View style={styles.container} accessible={true} accessibilityLabel={`${STRINGS.parkingStatus}: ${parkingText}`}>
    //   {!hideParkingText && <Image source={parkingImage} style={styles.image} resizeMode="contain" />}
    //   <Text style={{ ...styles.text, color: generateParkingStatusColor(parkingColor) }} allowFontScaling={false}>
    //     {parkingText || "Parking Unknown"}
    //   </Text>
    // </View>
    null // Temporarily disable parking reporting
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
  },
  image: {
    marginLeft: 1,
    marginTop: -8,
    marginBottom: -12,
    marginRight: 10,
    width: imageSize,
    height: imageSize,
  },
  text: {
    fontSize: Platform.OS === "web" ? 18 : 15,
  },
});

export default ParkingIndicator;
